import styled from 'styled-components';

export const BoldText = styled.div`
  font-weight: bolder;
  font-size: 16px;
`;

export const Contact = styled.a`
  text-decoration: underline;
`;
